/**
 * @file DeliveryHeatmapWidget.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-02-02
 * @modified 2026-02-02
 */

import React from 'react';

function DeliveryHeatmapWidget() {
  return (
    <div className="dashboard-card heatmap-card">
      <div className="card-header">
        <h3>
          <span className="material-symbols-rounded">map</span>
          Delivery Heatmap
        </h3>
        <span className="header-badge">3 months</span>
      </div>
      <div className="card-body heatmap-body">
        <iframe
          src="/delivery-heatmap.html"
          title="Delivery Heatmap"
          className="heatmap-iframe"
        />
      </div>
    </div>
  );
}

export default DeliveryHeatmapWidget;
